export function addEmptyPropertyFilters(query, propertyNames) {
  if (!query || !propertyNames.length) {
    return query;
  }
  const notHasPropertyFilters = propertyNames.map(property => ({
    operator: 'NOT_HAS_PROPERTY',
    property
  }));
  const updatedFilterGroups = (query.filterGroups || []).map(filterGroup => Object.assign({}, filterGroup, {
    filters: [...(filterGroup.filters || []), ...notHasPropertyFilters]
  }));
  return Object.assign({}, query, {
    filterGroups: updatedFilterGroups
  });
}